// How the storefront link unfurls — a Google result and a WhatsApp card drawn
// from the same title / description / first photo the server-rendered
// storefront puts in its <head>. Purely presentational: the live values are
// what the server emits, so this mirrors its fallbacks exactly.
interface Props {
  name: string
  title: string
  description: string
  heroSubcopy?: string
  imageUrl?: string | null
  url?: string | null
}

export function SeoPreview({ name, title, description, heroSubcopy, imageUrl, url }: Props) {
  const t = (title.trim() || `${name} · Order online`).slice(0, 70)
  const d = (description.trim() || heroSubcopy?.trim() || `Order online from ${name} for pickup and delivery.`).slice(0, 160)
  const host = (() => {
    try {
      return url ? new URL(url).host : 'order.yourcafe.com'
    } catch {
      return 'order.yourcafe.com'
    }
  })()
  return (
    <div className="grid gap-3 md:grid-cols-2" aria-label="Link preview">
      <div className="rounded-lg border bg-background p-3">
        <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">Google</p>
        <p className="truncate text-[12px] text-muted-foreground">{host}</p>
        <p className="mt-0.5 truncate text-[15px] leading-tight text-[#1a0dab]">{t}</p>
        <p className="mt-1 line-clamp-2 text-[12px] leading-snug text-muted-foreground">{d}</p>
      </div>
      <div className="rounded-lg border bg-background p-3">
        <p className="mb-1 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">WhatsApp</p>
        <div className="overflow-hidden rounded-md border bg-muted/40">
          {imageUrl ? (
            <img src={imageUrl} alt="" className="aspect-[1.91/1] w-full object-cover" />
          ) : (
            <div className="flex aspect-[1.91/1] w-full items-center justify-center text-[11px] text-muted-foreground">Add a photo to the library for a picture here</div>
          )}
          <div className="p-2">
            <p className="truncate text-[13px] font-semibold leading-tight">{t}</p>
            <p className="mt-0.5 line-clamp-2 text-[11px] leading-snug text-muted-foreground">{d}</p>
            <p className="mt-0.5 truncate text-[11px] text-muted-foreground">{host}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
